import { Type } from 'class-transformer';
import {
  ArrayMinSize,
  IsArray,
  IsDateString,
  IsIn,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  Min,
  ValidateNested,
} from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import {
  TRANSPORT_MODES,
  type TransportModeValue,
  TransportTemperatureDto,
} from './create-transport-document.dto';
import { TransportDocumentItemDto } from './transport-document-item.dto';

export class UpdateTransportDocumentDto
  extends TransportTemperatureDto
  implements TransportTemperatureDto
{
  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  customerId?: string;

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  causale?: string;

  @IsIn(TRANSPORT_MODES)
  @IsOptional()
  transportMode?: TransportModeValue;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  carrierName?: string;

  @IsInt()
  @IsOptional()
  @Min(1)
  packagesCount?: number;

  @IsNumber()
  @IsOptional()
  grossWeightKg?: number;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  goodsAppearance?: string;

  @IsDateString()
  @IsOptional()
  transportStartedAt?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  destinationAddress?: string;

  @IsArray()
  @ArrayMinSize(1)
  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => TransportDocumentItemDto)
  items?: TransportDocumentItemDto[];
}
